import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminReviewsIndex } from '@/types';
import { SubmissionReviewFilters } from './components/SubmissionReviewFilters';
import { SubmissionReviewTable } from './components/SubmissionReviewTable';

export default function Index({
  title,
  eventSlug,
  submissions,
  pagination,
  totalParticipants,
  filters,
  countries,
  reviewers,
}: AdminReviewsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">
            Submission Review
          </h1>
          <p className="text-muted-foreground">
            Review and manage all submissions
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Filters</CardTitle>
          </CardHeader>
          <CardContent>
            <SubmissionReviewFilters
              eventSlug={eventSlug}
              initialParams={filters}
              countries={countries}
              reviewers={reviewers}
            />
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <SubmissionReviewTable
              eventSlug={eventSlug}
              submissions={submissions}
              pagination={pagination}
              totalParticipants={totalParticipants}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
